import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Link from '../Link';
import history from '../../core/history';

import s from './Logo.css';

class Logo extends Component {
    static propTypes = {
        siteName: PropTypes.string.isRequired,
        logoImage: PropTypes.string,
        link: PropTypes.string,
        className: PropTypes.string,
        showMenu: PropTypes.bool,
    };

    static defaultProps = {
        siteName: null,
        logoImage: null,
        link: '/',
        showMenu: false
    }

    constructor(props) {
        super(props)
        this.state = {
            isClient: false
        }
    }

    componentDidMount() {
        this.setState({ isClient: true })
    }

    renderImage = (logo) => {
        const { showMenu } = this.props;
        return <img src={`/images/logo/${logo}`} className={cx(!showMenu ? 'displayBlock' : 'displayNone')}/>
    };

    renderSiteName = (colorClass = s.logoColor) => {
        const { siteName } = this.props;
        return <span className={cx(colorClass, s.logoTextTabViewWidth)}>{siteName || 'Site name'}</span>
    };

    render() {
        const { link, className, siteName, logoImage, homeLogo, showMenu, layoutType, scrollLogo } = this.props;
        const { isClient } = this.state;

        let location = history?.location ? history?.location?.pathname : null;

        return (
            isClient ?
                <Link to={link} className={className}>
                    {homeLogo && location === '/' && !logoImage && layoutType != 2 && this.renderImage(homeLogo)}
                    {homeLogo && location === '/' && !logoImage && showMenu && this.renderSiteName()}
                    {homeLogo && !scrollLogo && location === '/' && logoImage && layoutType != 2 && this.renderImage(homeLogo)}
                    {homeLogo && scrollLogo && location === '/' && logoImage && layoutType == 5 && this.renderImage(logoImage)}
                    {homeLogo && location === '/' && logoImage && layoutType == 2 && this.renderImage(logoImage)}
                    {homeLogo && location == '/' && showMenu && logoImage && this.renderImage(logoImage)}
                    {!homeLogo && location === '/' && logoImage && this.renderImage(logoImage)}
                    {!homeLogo && !logoImage && siteName && location && location !== '/' && this.renderSiteName()}
                    {!homeLogo && !logoImage && siteName && location && location === '/' && <span className={cx(!showMenu && (layoutType == '2' ? s.logoColor : layoutType == '5' ? s.whiteColor : s.whiteColor), 'logoColor', s.logoTextTabViewWidth)}>{siteName}</span>}
                    {!homeLogo && !logoImage && siteName == null && this.renderSiteName()}
                    {logoImage && location && location !== '/' && <img src={`/images/logo/${logoImage}`} />}
                    {!logoImage && homeLogo && location && location !== '/' && siteName && this.renderSiteName()}
                </Link> : <></>
        );
    }
}

const mapState = (state) => ({
    siteName: state.siteSettings.data.siteName,
    logoImage: state.siteSettings.data.Logo,
    homeLogo: state.siteSettings.data.homeLogo,
    showMenu: state.toggle.showMenu,
    layoutType: state.siteSettings.data.homePageType
});

const mapDispatch = {};

export default compose(
    connect(mapState, mapDispatch),
    withStyles(s)
)(Logo);